import { portalBootstrapInitializer } from './modules/core/services/portal-bootstrap.service';
import { createTranslateLoader } from './modules/core/core.module';
const ɵ0 = (createTranslateLoader), ɵ1 = portalBootstrapInitializer;
export class AppModule {
}
export { ɵ0, ɵ1 };
